<template>
  <div class="wap_index5 main">
    <div class="box_bg">
      <div class="wap_index5_title">下载中心</div>
      <div class="wap_index5_box">
        <div>
          <div class="wap_index5_box_bg wap_index5_box_bg1"></div>
          <div class="wap_index5_box_ios">IOS下载</div>
          <div class="wap_index5_box_a" @click="iosTo()">立即下载</div>
        </div>
        <div>
          <div class="wap_index5_box_bg wap_index5_box_bg2"></div>
          <div class="wap_index5_box_android">Android</div>
          <div class="wap_index5_box_a" @click="azTo()">立即下载</div>
        </div>
        <div>
          <div class="wap_index5_box_bg wap_index5_box_bg3"></div>
          <div class="wap_index5_box_android wap_index5_box_pc">
            千年游戏盒子电脑端
          </div>
          <div class="wap_index5_box_a" @click="pcTo()">立即下载</div>
        </div>
        <div>
          <div class="wap_index5_box_special">
            <div class="wap_index5_box_qr">
              <!-- <img src="../../assets/images/pc/qrcode.png" alt="千年游戏盒子" /> -->
              <img :src="qrcodeUrl" alt="千年游戏盒子" />
            </div>
            <div class="wap_index5_box_size">长按保存 扫码下载</div>
          </div>
          <div @click="savepicture" class="qr_pop" v-if="saveShow">
            <div>保存图片</div>
          </div>
        </div>
        <div>
          <div class="wap_index5_box_bg wap_index5_box_bg4"></div>
          <div class="wap_index5_box_android">模拟器</div>
          <div class="wap_index5_box_a" @click="azTomn()">立即下载</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="viewportHeight" class="wap_index5_location"></div> -->
    <div class="wap_index5_bottom">
      <div>
        <div class="flex">
          <!-- <div>《用户协议》</div> -->
          <!-- <a href="./privacy.html" target="_blank">《隐私政策》</a> -->
          <router-link to="yinsi" style="color: white" target="_blank">《隐私政策》</router-link>
        </div>
        <div>江阴千游网络科技有限公司</div>
        <div>请您合理控制游戏时间，避免沉溺游戏影响生活</div>
        <div>注意自我保护，防范网络陷阱</div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2022030317号-7</a>
        <div> 违规投诉/举报邮箱：xiecheng1@3975.com</div>
        <div> 违规投诉/举报邮箱：jiankongzu2024@163.com </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qrcodeUrl } from "@/utils/download";
import okToast from "@/components/c-toast/toast";
import { isMobile } from "@/utils/index";
export default {
  data() {
    return {
      viewportHeight: true,
      saveShow: false,
      qrcodeUrl: qrcodeUrl,
    };
  },
  mounted() { },
  created() { },
  methods: {
    isMobile,
    iosTo() {
      this.$emit("update", 0, true);
    },
    azTomn() {
      this.$emit("update", 9, true);
    },
    azTo() {
      this.$emit("update", 1, true);
    },
    pcTo() {
      this.$emit("update", 2, true);
    },
    // 右键保存
    qrMenu(e) {
      e.preventDefault();
      if (!this.isMobile()) {
        this.pcqrShow = !this.pcqrShow;
      }
    },
    navigation(index) {
      this.navList.forEach((item) => {
        item.show = false;
      });
      this.navList[index].show = true;
    },
    savepicture() {
      this.saveShow = false;
      this.saveImage();
    },
    closeQR() {
      this.pcqrShow = false;
      this.saveShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/wap_index.css");

.box_bg {
  width: 16.75rem
    /* 335/20 */
  ;
  margin: 0 auto;
  width: 90%;
}

.wap_index5 {
  background: url("../../assets/images/web/two_bg.png") no-repeat center;
  background-size: cover;
  position: relative;
}

.wap_index5_title {
  color: #fff;
  font-size: 0.533333rem
    /* 20/37.5 */
  ;
  font-weight: bold;
  padding-top: 1.466667rem
    /* 55/37.5 */
  ;
  padding-bottom: 0.533333rem
    /* 20/37.5 */
  ;
  text-align: center;
}

.wap_index5_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.wap_index5_box>div {
  width: 4.16rem
    /* 156/37.5 */
  ;
  // height: 5.146667rem
  //   /* 193/37.5 */
  // ;
  height: 4.8rem;
  border-radius: 0.533333rem
    /* 20/37.5 */
  ;
  margin-bottom: 0.533333rem
    /* 20/37.5 */
  ;
  position: relative;
  box-sizing: border-box;
  padding-top: 0.48rem
    /* 18/37.5 */
  ;
  text-align: center;
  background: rgba(255, 255, 255, 0.18);
}

.wap_index5_box>div:nth-child(4) {
  padding-top: 0;
}

.wap_index5_box_special {
  padding-top: 0.48rem
    /* 18/37.5 */
  ;
  padding-top: 0.373333rem
    /* 14/37.5 */
  ;
  height: 100%;
  position: relative;
  z-index: 2;
}

.qr_pop {
  position: absolute;
  right: -72%;
  top: 17%;
  width: 2.666667rem
    /* 100/37.5 */
  ;
  height: 1.6rem
    /* 60/37.5 */
  ;
  background: #fff;
  border-radius: 0.266667rem
    /* 10/37.5 */
  ;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  font-weight: bold;
  color: #000;
  line-height: 1.6rem
    /* 60/37.5 */
  ;
}

.wap_index5_bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 2.693333rem/* 101/37.5 */;
  background: #000000;
  opacity: 0.98;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-size: 0.28rem
    /* 12/37.5 */
  ;
}

.wap_index5_bottom>div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wap_index5_bottom a {
  color: #fff;
  font-size: 0.28rem
    /* 12/37.5 */
  ;
  text-align: center;
  background: #000000;
}

.wap_index5_box_bg {
  width: 2.133333rem
    /* 80/37.5 */
  ;
  height: 1.973333rem
    /* 74/37.5 */
  ;
  margin: 0 auto;
}

.wap_index5_box_ios {
  color: #52bcff;
  font-size: 0.426667rem
    /* 16/37.5 */
  ;
  font-weight: bold;
  padding-bottom: 0.533333rem
    /* 20/37.5 */
  ;
}

.wap_index5_box_android {
  color: #ff9262;
  font-size: 0.426667rem
    /* 16/37.5 */
  ;
  font-weight: bold;
  padding-bottom: 0.533333rem
    /* 20/37.5 */
  ;
}

.wap_index5_box_pc {
  color: #ffcd42;
  font-size: 0.426667rem
    /* 16/37.5 */
  ;
  font-weight: bold;
  padding-bottom: 0.533333rem
    /* 20/37.5 */
  ;
}

.wap_index5_box_a {
  display: block;
  width: 2.533333rem
    /* 95/37.5 */
  ;
  height: 0.853333rem
    /* 32/37.5 */
  ;
  background: #ffffff;
  border-radius: 0.48rem
    /* 18/37.5 */
  ;
  line-height: 0.853333rem
    /* 32/37.5 */
  ;
  text-align: center;
  color: #1d1d1d;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  margin: 0 auto;
}

.wap_index5_box_bg1 {
  background: url("../../assets/images/web/ios.png") no-repeat;
  background-size: cover;
}

.wap_index5_box_bg2 {
  background: url("../../assets/images/web/android.png") no-repeat;
  background-size: cover;
}

.wap_index5_box_bg3 {
  background: url("../../assets/images/web/pc.png") no-repeat;
  background-size: cover;
}
.wap_index5_box_bg4{
  background: url("../../assets/images/pc/mn.png") no-repeat;
  background-size: cover;
}
.wap_index5_box_qr {
  width: 3.28rem
    /* 123/37.5 */
  ;
  height: 3.306667rem
    /* 124/37.5 */
  ;
  margin: 0 auto;
  /* background: url("../../assets/images/web/qr.png") no-repeat center; */
  background-size: cover;
}

.wap_index5_box_qr img {
  display: block;
  width: 100%;
  height: 100%;
}

.wap_index5_box_size {
  padding-top: 0.16rem
    /* 6/37.5 */
  ;
  font-size: 0.373333rem
    /* 14/37.5 */
  ;
  color: #ffffff;
}

.wap_index5_location {
  position: absolute;
  right: 0.56rem
    /* 21/37.5 */
  ;
  bottom: 3.226667rem
    /* 121/37.5 */
  ;
  opacity: 0.76;
  width: 5.04rem
    /* 189/37.5 */
  ;
  height: 5.04rem
    /* 189/37.5 */
  ;
  background: url("../../assets/images/pc/download-main-infobg1.gif") no-repeat;
  background-size: cover;
}

@media (max-width: 750px) and (max-height: 667px) {
  .wap_index5_title {
    padding-top: 1.6rem
      /* 60/37.5 */
    ;
    color: #fff;
    font-size: 0.533333rem
      /* 20/37.5 */
    ;
    font-weight: bold;
    text-align: center;
    padding-top: 1.466667rem
      /* 55/37.5 */
    ;
    padding-bottom: 0.4rem
      /* 15/37.5 */
    ;
  }

  .wap_index5_box>div {
    width: 3.893333rem
      /* 146/37.5 */
    ;
    // height: 4.08rem
    //   /* 153/37.5 */
    // ;
    height: 3.8rem;
    border-radius: 0.4rem
      /* 15/37.5 */
    ;
    // margin-bottom: 0.666667rem
    //   /* 25/37.5 */
    // ;
    margin-bottom: 0.3rem
    ;
    position: relative;
    box-sizing: border-box;
    padding-top: 0.48rem
      /* 18/37.5 */
    ;
    text-align: center;
  }

  .wap_index5_box_qr {
    width: 2.666667rem
      /* 100/37.5 */
    ;
    height: 2.773333rem
      /* 104/37.5 */
    ;
  }

  .wap_index5_box_bg {
    width: 1.6rem
      /* 60/37.5 */
    ;
    height: 1.44rem
      /* 54/37.5 */
    ;
    margin: 0 auto;
  }

  .wap_index5_box_ios {
    font-size: 0.373333rem
      /* 14/37.5 */
    ;
    padding-bottom: 0.4rem
      /* 15/37.5 */
    ;
  }

  .wap_index5_box_android {
    font-size: 0.373333rem
      /* 14/37.5 */
    ;
    padding-bottom: 0.4rem
      /* 15/37.5 */
    ;
  }

  .wap_index5_box_pc {
    font-size: 0.373333rem
      /* 14/37.5 */
    ;
    padding-bottom: 0.4rem
      /* 15/37.5 */
    ;
  }

  .wap_index5_box_a {
    width: 2.533333rem
      /* 95/37.5 */
    ;
    height: 0.8rem
      /* 30/37.5 */
    ;
    background: #ffffff;
    border-radius: 0.48rem
      /* 18/37.5 */
    ;
    line-height: 0.533333rem
      /* 20/37.5 */
    ;
    text-align: center;
    color: #1d1d1d;
    line-height: 0.8rem
      /* 30/37.5 */
    ;
    font-size: 0.32rem
      /* 12/37.5 */
    ;
    margin: 0 auto;
  }

  .wap_index5_location {
    display: none;
  }
}

@media (max-width: 750px) and (max-height: 600px) {
  .wap_index5_box_bg {
    width: 1.493333rem
      /* 56/37.5 */
    ;
    height: 1.333333rem
      /* 50/37.5 */
    ;
    margin: 0 auto;
  }

  .wap_index5_box_ios {
    padding-bottom: 0.266667rem
      /* 10/37.5 */
    ;
  }

  .wap_index5_box_a {
    height: 0.693333rem
      /* 26/37.5 */
    ;
    line-height: 0.693333rem
      /* 26/37.5 */
    ;
    font-size: 0.266667rem
      /* 10/37.5 */
    ;
  }

  .wap_index5_box_android {
    padding-bottom: 0.266667rem
      /* 10/37.5 */
    ;
  }

  .wap_index5_box_qr {
    width: 2.24rem
      /* 84/37.5 */
    ;
    height: 2.346667rem
      /* 88/37.5 */
    ;
  }

  .wap_index5_box_special {
    padding-top: 0.4rem
      /* 15/37.5 */
    ;
  }

  .wap_index5_box_size {
    padding-top: 0.08rem
      /* 3/37.5 */
    ;
    font-size: 0.266667rem
      /* 10/37.5 */
    ;
    color: #ffffff;
  }

  .wap_index5_box>div {
    margin-bottom: 0.266667rem
      /* 10/37.5 */
    ;
    height: 3.466667rem
      /* 130/37.5 */
    ;

    padding-top: 0.4rem
      /* 15/37.5 */
    ;
  }
}
</style>
